import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import {isUserLoggedIn} from "./utils/auth";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./pages/Login/Login'))
const Page404 = React.lazy(() => import('./components/ErrorPages/Page404/Page404'))
const Page500 = React.lazy(() => import('./components/ErrorPages/Page500/Page500'))
const ResetPassword = React.lazy(() => import('./pages/ResetPassword/ResetPassword'))
const ForgotPassword = React.lazy(() => import('./pages/ForgotPassword/ForgotPassword'))


const isULoggedIn = isUserLoggedIn()

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/password-reset" name="Password Reset" element={<ResetPassword />} />
            <Route exact path="/forgot-password" name="Forgot Password" element={<ForgotPassword />} />

            <Route
              path="*"
              name="Home"
              element={isULoggedIn === true ? <DefaultLayout /> : <Navigate to="/login" />}
            />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
